import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCloudSolutionsPath } from "@core/schema/paths/getCloudSolutionsPath.js";

export function getReasonsHR(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "HR řešení na míru",
			desc: "Jsme tu pro firmy, kterým nestačí krabicové řešení a potřebují vývoj softwaru nebo jiné řešení na míru (nejen) pro HR.",
		},
		{
			title: "Nejsme jen vývojáři",
			desc: "Máme přesah do narovnávání firemních procesů, digitalizace nebo automatizace. Pomůžeme vám snížit náklady a ušetřit čas.",
		},
		{
			title: "S HR máme bohaté zkušenosti",
			desc: "V oblasti HR nejsme nováčkem. Dlouhé roky vytváříme kariérní weby/sekce (např. firmy VertiFlex a BRANO), HR software i komplexní řešení optimalizující náborové procesy (například aplikace [https://www.tymbe.cz][[Tymbe]]).",
		},
		{
			title: "Podpora a snadné škálování",
			desc: "Po celou dobu provozování systémů vám bude k ruce naše specializovaná podpora. Jakýkoliv software můžeme do budoucna snadno přizpůsobit vašim potřebám.",
		},
		{
			title: "Vyvíjíme na cloudu",
			desc: `Specializujeme se na [${getCloudSolutionsPath(tenant)}][[cloudová řešení]], tím vám ušetříme peníze za servery, které byste jinak museli provozovat a starat se o ně.`,
		},
	];
}
